import React, { useState } from 'react';
import axios from 'axios';
import { ArrowLeft, Play } from 'lucide-react';
import { toast } from '../ui/Toast';

const VoiceYoutubeExtract = ({ onResult, onBack }) => {
  const [url, setUrl] = useState('');
  const [processing, setProcessing] = useState(false);
  const [action, setAction] = useState('transcribe');

  const isValidUrl = url.includes('youtube.com') || url.includes('youtu.be');

  const handleExtract = async () => {
    if (!isValidUrl) return;
    setProcessing(true);
    try {
      const token = localStorage.getItem('oracle_token');
      const ytRes = await axios.post('/api/voice/youtube', { url }, {
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
        timeout: 30000,
      });

      const text = ytRes.data.text;

      if (action === 'transcribe') {
        onResult(text, 'Transcription YouTube');
      } else {
        const endpoint = action === 'summarize' ? '/api/voice/summarize' : '/api/voice/rewrite';
        const aiRes = await axios.post(endpoint, { text }, {
          headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
          timeout: 60000,
        });
        onResult(aiRes.data.markdown, action === 'summarize' ? 'Résumé YouTube' : 'Réécriture YouTube');
      }
    } catch (err) {
      toast.error('Erreur: ' + (err.response?.data?.details || err.message));
    } finally {
      setProcessing(false);
    }
  };

  if (processing) {
    return (
      <div style={{ textAlign: 'center', padding: '40px 0' }}>
        <div style={{ width: 40, height: 40, border: '3px solid #475569', borderTopColor: '#f97316', borderRadius: '50%', animation: 'spin 1s linear infinite', margin: '0 auto 16px' }} />
        <div style={{ color: '#94a3b8', fontSize: 14 }}>Extraction en cours...</div>
        <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
      </div>
    );
  }

  return (
    <div>
      <button onClick={onBack} style={styles.backBtn}>
        <ArrowLeft size={14} /> Retour
      </button>

      {/* Action selector */}
      <div style={styles.actionRow}>
        {[['transcribe', 'Transcrire'], ['summarize', 'Résumer'], ['rewrite', 'Réécrire']].map(([key, label]) => (
          <button key={key} onClick={() => setAction(key)}
            style={{ ...styles.actionBtn, ...(action === key ? styles.actionActive : {}) }}>
            {label}
          </button>
        ))}
      </div>

      {/* URL input */}
      <div style={styles.inputRow}>
        <input
          type="text"
          value={url}
          onChange={(e) => setUrl(e.target.value)}
          placeholder="https://youtube.com/watch?v=..."
          style={styles.input}
        />
        <button onClick={handleExtract} disabled={!isValidUrl}
          style={{ ...styles.extractBtn, ...(isValidUrl ? {} : styles.extractBtnDisabled) }}>
          <Play size={14} /> Extraire
        </button>
      </div>

      <div style={{ color: '#64748b', fontSize: 11, marginTop: 8 }}>
        Collez un lien YouTube pour extraire et transcrire les sous-titres
      </div>
    </div>
  );
};

const styles = {
  backBtn: {
    background: 'none', border: 'none', color: '#94a3b8', cursor: 'pointer',
    display: 'flex', alignItems: 'center', gap: 4, fontSize: 13, marginBottom: 16, padding: 0,
  },
  actionRow: { display: 'flex', gap: 6, marginBottom: 16 },
  actionBtn: {
    flex: 1, padding: '8px 0', borderRadius: 6, border: '1px solid #475569',
    background: '#334155', color: '#94a3b8', cursor: 'pointer', fontSize: 12, fontWeight: 500,
  },
  actionActive: { background: '#f97316', color: 'white', borderColor: '#f97316' },
  inputRow: { display: 'flex', gap: 8 },
  input: {
    flex: 1, padding: '10px 12px', borderRadius: 8, border: '1px solid #475569',
    background: '#0f172a', color: '#e2e8f0', fontSize: 13, outline: 'none',
  },
  extractBtn: {
    padding: '10px 16px', borderRadius: 8, border: 'none', background: '#f97316',
    color: 'white', cursor: 'pointer', fontSize: 13, fontWeight: 600,
    display: 'flex', alignItems: 'center', gap: 6, whiteSpace: 'nowrap',
  },
  extractBtnDisabled: { opacity: 0.4, cursor: 'not-allowed' },
};

export default VoiceYoutubeExtract;
